import script from "./dbgys-invoice-main.vue?vue&type=script&lang=tsx&setup=true"
export * from "./dbgys-invoice-main.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__